import { useQueryClient } from '@tanstack/react-query';
import type { InfiniteData } from 'query';
import { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import {
  getBookmarksFeedInfiniteQueryKey,
  getContentObjectDetailQueryKey,
  getFeedKey,
} from 'features/feed/queries/keys';

type FeedCacheItem = { post?: { id: string; status: string } };

export const useUpdateMarkAsRead = () => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ postId }: { postId: string }) => {
      queryClient.setQueriesData<FeedCacheItem>(
        { queryKey: getContentObjectDetailQueryKey({ id: postId }) },
        (contentObject) =>
          contentObject?.post ? { ...contentObject, post: { ...contentObject.post, status: 'read' } } : contentObject,
      );

      const feedQueryKeys = [getFeedKey(), getBookmarksFeedInfiniteQueryKey({})];

      for (const queryKey of feedQueryKeys) {
        queryClient.setQueriesData<InfiniteData<FeedCacheItem[]>>({ queryKey }, (oldData) => {
          if (!oldData) {
            return oldData;
          }

          return {
            ...oldData,
            pages: oldData.pages.map((page) =>
              page.map((pageItem) => {
                const { post } = pageItem;

                if (post?.id !== postId) {
                  return pageItem;
                }

                return { ...pageItem, post: { ...post, status: 'read' } };
              }),
            ),
          };
        });
      }
    },
    [queryClient],
  );
};
